(function () {
  'use strict';

  var STORAGE_KEY = 'visit_ctx_v1';
  var COOKIE_KEY = 'visit_ctx_v1';
  var LEGACY_STORAGE_KEYS = ['marketing_attribution_v1'];
  var CART_FIRST = '__src_a';
  var CART_LAST = '__src_b';
  var CART_META = '__src_c';
  var STORAGE_TTL = 90 * 24 * 60 * 60 * 1000;
  var MAX_VISITS = 20;
  var SYNC_TIMEOUT = 1500;
  var STORE_HOSTS = ['ampriomilano.com'];
  var AI_REFERRERS = {
    'chatgpt.com': 'chatgpt',
    'perplexity.ai': 'perplexity',
    'claude.ai': 'claude',
    'gemini.google.com': 'gemini',
    'copilot.microsoft.com': 'microsoft_copilot',
    'you.com': 'you',
    'phind.com': 'phind'
  };
  var CLICK_ID_VENDORS = {
    dclid: { source: 'google', medium: 'cpc' },
    msclkid: { source: 'microsoft', medium: 'cpc' },
    ttclid: { source: 'tiktok', medium: 'paid_social' },
    scclid: { source: 'snapchat', medium: 'paid_social' },
    li_fat_id: { source: 'linkedin', medium: 'paid_social' },
    epik: { source: 'pinterest', medium: 'paid_social' },
    twclid: { source: 'x', medium: 'paid_social' },
    rdt_cid: { source: 'reddit', medium: 'paid_social' }
  };
  var STRICT_COUNTRIES = {
    EU: 1, AM: 1, DE: 1, FR: 1, IT: 1, ES: 1, NL: 1, BE: 1, AT: 1, PT: 1,
    IE: 1, PL: 1, RO: 1, CZ: 1, GR: 1, SE: 1, HU: 1, FI: 1, DK: 1, SK: 1,
    SI: 1, LU: 1, EE: 1, LV: 1, LT: 1, MT: 1, CY: 1, BG: 1, HR: 1, GB: 1,
    CH: 1, NO: 1, TR: 1
  };
  var state = {
    policy: 'strict',
    region: '',
    analyticsAllowed: false,
    marketingAllowed: false,
    initialized: false
  };
  var snapshot = emptySnapshot();
  var readySequence = 0;
  var clarityIdentity = '';
  var lastSyncKey = '';
  var syncPromise = null;
  var shopifyRetry = 0;
  var lateCaptureScheduled = false;
  var LATE_CAPTURE_MS = 15000;

  function emptySnapshot() {
    return {
      version: 1,
      created_at: 0,
      expires_at: 0,
      visitor_id: '',
      first_touch: null,
      last_non_direct_touch: null,
      last_visit: null,
      visits: [],
      total_sessions: 0,
      yandex_client_id: ''
    };
  }

  function clone(value) {
    try {
      return JSON.parse(JSON.stringify(value));
    } catch (error) {
      return null;
    }
  }

  function storageAvailable() {
    try {
      var testKey = STORAGE_KEY + '_test';
      window.localStorage.setItem(testKey, '1');
      window.localStorage.removeItem(testKey);
      return true;
    } catch (error) {
      return false;
    }
  }

  function parseStored(raw) {
    if (!raw) return null;
    try {
      var stored = JSON.parse(raw);
      if (!stored || stored.version !== 1 || !stored.expires_at || stored.expires_at <= Date.now()) return null;
      stored.visits = Array.isArray(stored.visits) ? stored.visits.slice(-MAX_VISITS) : [];
      return stored;
    } catch (error) {
      return null;
    }
  }

  function readStored() {
    if (storageAvailable()) {
      var current = parseStored(window.localStorage.getItem(STORAGE_KEY));
      if (current) return current;
      for (var i = 0; i < LEGACY_STORAGE_KEYS.length; i += 1) {
        var legacy = parseStored(window.localStorage.getItem(LEGACY_STORAGE_KEYS[i]));
        if (legacy) {
          try {
            window.localStorage.removeItem(LEGACY_STORAGE_KEYS[i]);
          } catch (error) {}
          snapshot = legacy;
          persist();
          return clone(legacy) || emptySnapshot();
        }
      }
      window.localStorage.removeItem(STORAGE_KEY);
    }
    return readCookieBackup();
  }

  function hasStoredMarks() {
    return !!(
      snapshot.visitor_id ||
      snapshot.first_touch ||
      snapshot.last_non_direct_touch ||
      (snapshot.visits && snapshot.visits.length)
    );
  }

  function persist() {
    if (!state.analyticsAllowed && !state.marketingAllowed) return;
    if (!hasStoredMarks()) return;
    if (!snapshot.created_at) snapshot.created_at = Date.now();
    if (!snapshot.expires_at) snapshot.expires_at = snapshot.created_at + STORAGE_TTL;
    if (storageAvailable()) {
      try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(snapshot));
        for (var i = 0; i < LEGACY_STORAGE_KEYS.length; i += 1) {
          window.localStorage.removeItem(LEGACY_STORAGE_KEYS[i]);
        }
      } catch (error) {}
    }
    persistCookieBackup();
  }

  function clearStored() {
    snapshot = emptySnapshot();
    try {
      window.localStorage.removeItem(STORAGE_KEY);
      for (var i = 0; i < LEGACY_STORAGE_KEYS.length; i += 1) {
        window.localStorage.removeItem(LEGACY_STORAGE_KEYS[i]);
      }
    } catch (error) {
      snapshot = emptySnapshot();
    }
    document.cookie = COOKIE_KEY + '=; path=/; max-age=0; SameSite=Lax';
    for (var j = 0; j < LEGACY_STORAGE_KEYS.length; j += 1) {
      document.cookie = LEGACY_STORAGE_KEYS[j] + '=; path=/; max-age=0; SameSite=Lax';
    }
    queueCartSync();
  }

  function encodeCookie(value) {
    try {
      return encodeURIComponent(JSON.stringify(value));
    } catch (error) {
      return '';
    }
  }

  function decodeCookie(value) {
    if (!value) return null;
    try {
      return JSON.parse(decodeURIComponent(value));
    } catch (error) {}
    try {
      return JSON.parse(decodeURIComponent(escape(window.atob(value))));
    } catch (error) {
      return null;
    }
  }

  function packMarks(touch) {
    if (!touch) return null;
    var utm = touch.utm || {};
    var meta = touch.meta || {};
    var google = touch.google || {};
    return compact({
      source: touch.source,
      medium: touch.medium,
      channel: touch.ch || touch.channel,
      referrer: touch.rh || touch.referrer,
      utm_source: utm.source,
      utm_medium: utm.medium,
      utm_campaign: utm.campaign,
      utm_id: utm.id,
      utm_content: utm.content,
      utm_term: utm.term,
      gclid: google.gclid,
      gbraid: google.gbraid,
      wbraid: google.wbraid,
      dclid: touch.clicks && touch.clicks.dclid,
      msclkid: touch.clicks && touch.clicks.msclkid,
      ttclid: touch.clicks && touch.clicks.ttclid,
      scclid: touch.clicks && touch.clicks.scclid,
      li_fat_id: touch.clicks && touch.clicks.li_fat_id,
      epik: touch.clicks && touch.clicks.epik,
      twclid: touch.clicks && touch.clicks.twclid,
      rdt_cid: touch.clicks && touch.clicks.rdt_cid,
      srsltid: google.srsltid,
      google_campaign: google.campaign,
      google_adgroup: google.adgroup,
      google_keyword: google.keyword,
      google_network: google.network,
      google_device: google.device,
      fbclid: meta.fbclid,
      meta_adset_id: meta.adset_id,
      meta_ad_id: meta.ad_id,
      meta_placement: meta.placement,
      landing: touch.landing,
      seconds_since_previous: touch.seconds_since_previous,
      time: touch.time
    });
  }

  function unpackMarks(packed) {
    if (!packed) return null;
    var utm = packed.u || packed.utm || {};
    return {
      utm: compact({
        source: packed.utm_source || utm.source,
        medium: packed.utm_medium || utm.medium,
        campaign: packed.utm_campaign || utm.campaign,
        id: packed.utm_id || utm.id,
        content: packed.utm_content || utm.content,
        term: packed.utm_term || utm.term
      }),
      meta: compact({
        fbclid: packed.fbclid,
        adset_id: packed.meta_adset_id,
        ad_id: packed.meta_ad_id,
        placement: packed.meta_placement
      }),
      google: compact({
        gclid: packed.gclid || (packed.google && packed.google.gclid),
        gbraid: packed.gbraid || (packed.google && packed.google.gbraid),
        wbraid: packed.wbraid || (packed.google && packed.google.wbraid),
        srsltid: packed.srsltid || (packed.google && packed.google.srsltid),
        campaign: packed.google_campaign,
        adgroup: packed.google_adgroup,
        keyword: packed.google_keyword,
        network: packed.google_network,
        device: packed.google_device
      }),
      clicks: compact({
        dclid: packed.dclid,
        msclkid: packed.msclkid,
        ttclid: packed.ttclid,
        scclid: packed.scclid,
        li_fat_id: packed.li_fat_id,
        epik: packed.epik,
        twclid: packed.twclid,
        rdt_cid: packed.rdt_cid
      }),
      source: packed.source || '',
      medium: packed.medium || '',
      landing: packed.landing || '',
      seconds_since_previous: packed.seconds_since_previous,
      referrer: packed.referrer || packed.r || '',
      rh: packed.referrer || packed.r || packed.rh || '',
      ch: packed.channel || packed.ch || '',
      time: packed.time || packed.t || '',
      session: packed.session || ''
    };
  }

  function cookieBackup() {
    return {
      version: 1,
      expires_at: snapshot.expires_at,
      visitor_id: snapshot.visitor_id,
      first: packMarks(snapshot.first_touch),
      last: packMarks(snapshot.last_non_direct_touch),
      visits: (snapshot.visits || []).map(packMarks).slice(-5)
    };
  }

  function persistCookieBackup() {
    var value = encodeCookie(cookieBackup());
    if (!value || value.length > 3500) return;
    var remaining = Math.max(0, Math.floor((snapshot.expires_at - Date.now()) / 1000));
    var parts = [
      COOKIE_KEY + '=' + value,
      'path=/',
      'max-age=' + remaining,
      'SameSite=Lax'
    ];
    if (window.location.protocol === 'https:') parts.push('Secure');
    document.cookie = parts.join('; ');
  }

  function readCookieBackup() {
    var value = cookieValue(COOKIE_KEY, 4000);
    if (!value) {
      for (var i = 0; i < LEGACY_STORAGE_KEYS.length; i += 1) {
        value = cookieValue(LEGACY_STORAGE_KEYS[i], 4000);
        if (value) break;
      }
    }
    var stored = decodeCookie(value);
    if (!stored) {
      document.cookie = COOKIE_KEY + '=; path=/; max-age=0; SameSite=Lax';
      return emptySnapshot();
    }
    if (stored.v === 1 && stored.e) {
      if (stored.e <= Date.now()) {
        document.cookie = COOKIE_KEY + '=; path=/; max-age=0; SameSite=Lax';
        return emptySnapshot();
      }
      return {
        version: 1,
        created_at: stored.e - STORAGE_TTL,
        expires_at: stored.e,
        visitor_id: stored.i || '',
        first_touch: unpackMarks(stored.f),
        last_non_direct_touch: unpackMarks(stored.l),
        last_visit: unpackMarks(stored.l) || unpackMarks(stored.f),
        visits: (stored.visits || []).map(unpackMarks).filter(function (touch) { return !!touch; }),
        yandex_client_id: cookieValue('_ym_uid', 200)
      };
    }
    if (stored.version === 1 && stored.expires_at && !stored.first_touch && (stored.first || stored.last || stored.visitor_id)) {
      if (stored.expires_at <= Date.now()) {
        document.cookie = COOKIE_KEY + '=; path=/; max-age=0; SameSite=Lax';
        return emptySnapshot();
      }
      return {
        version: 1,
        created_at: stored.expires_at - STORAGE_TTL,
        expires_at: stored.expires_at,
        visitor_id: stored.visitor_id || '',
        first_touch: unpackMarks(stored.first),
        last_non_direct_touch: unpackMarks(stored.last),
        last_visit: unpackMarks(stored.last) || unpackMarks(stored.first),
        visits: (stored.visits || []).map(unpackMarks).filter(function (touch) { return !!touch; }),
        yandex_client_id: cookieValue('_ym_uid', 200)
      };
    }
    if (!stored.version || stored.version !== 1 || !stored.expires_at || stored.expires_at <= Date.now()) {
      document.cookie = COOKIE_KEY + '=; path=/; max-age=0; SameSite=Lax';
      for (var j = 0; j < LEGACY_STORAGE_KEYS.length; j += 1) {
        document.cookie = LEGACY_STORAGE_KEYS[j] + '=; path=/; max-age=0; SameSite=Lax';
      }
      return emptySnapshot();
    }
    stored.visits = [];
    return stored;
  }

  function safeValue(value, maxLength) {
    if (typeof value !== 'string') return '';
    return value.replace(/[\u0000-\u001f\u007f]/g, '').trim().slice(0, maxLength || 200);
  }

  function parameter(params, names) {
    for (var i = 0; i < names.length; i += 1) {
      var value = params.get(names[i]);
      if (value) return safeValue(value, 200);
    }
    return '';
  }

  function compact(object) {
    var result = {};
    Object.keys(object).forEach(function (key) {
      if (object[key] !== '' && object[key] !== null && typeof object[key] !== 'undefined') {
        result[key] = object[key];
      }
    });
    return result;
  }

  function isMarketingParam(name) {
    if (!name) return false;
    var lower = String(name).toLowerCase();
    if (lower.indexOf('utm_') === 0) return true;
    return lower === 'gclid' ||
      lower === 'gclsrc' ||
      lower === 'dclid' ||
      lower === 'fbclid' ||
      lower === 'msclkid' ||
      lower === 'ttclid' ||
      lower === 'scclid' ||
      lower === 'twclid' ||
      lower === 'li_fat_id' ||
      lower === 'epik' ||
      lower === 'rdt_cid' ||
      lower === 'mc_cid' ||
      lower === 'mc_eid' ||
      lower === 'srsltid' ||
      lower === 'gbraid' ||
      lower === 'wbraid' ||
      lower === 'campaign' ||
      lower === 'campaignid' ||
      lower === 'adgroup' ||
      lower === 'adgroupid' ||
      lower === 'creative' ||
      lower === 'keyword' ||
      lower === 'network' ||
      lower === 'device';
  }

  function safeLocation(value) {
    if (!value) return '';
    try {
      var url = new URL(value, window.location.origin);
      var kept = new URLSearchParams();
      url.searchParams.forEach(function (paramValue, key) {
        if (isMarketingParam(key) && paramValue) kept.append(key, paramValue);
      });
      var query = kept.toString();
      return safeValue(url.origin + url.pathname + (query ? '?' + query : ''), 500);
    } catch (error) {
      return '';
    }
  }

  function cookieValue(name, maxLength) {
    var parts = document.cookie ? document.cookie.split(';') : [];
    for (var i = 0; i < parts.length; i += 1) {
      var pair = parts[i].trim();
      if (pair.indexOf(name + '=') === 0) {
        try {
          return safeValue(decodeURIComponent(pair.slice(name.length + 1)), maxLength || 200);
        } catch (error) {
          return safeValue(pair.slice(name.length + 1), maxLength || 200);
        }
      }
    }
    return '';
  }

  function parseGclAw() {
    var raw = cookieValue('_gcl_aw', 400);
    if (!raw) return '';
    var parts = raw.split('.');
    if (parts.length < 3) return '';
    return safeValue(parts.slice(2).join('.'), 400);
  }

  function livePixelIds() {
    return compact({
      shopify_y: cookieValue('_shopify_y', 200),
      shopify_s: cookieValue('_shopify_s', 200),
      fbp: cookieValue('_fbp', 200),
      fbc: cookieValue('_fbc', 200),
      gcl_aw: cookieValue('_gcl_aw', 400),
      gcl_au: cookieValue('_gcl_au', 400),
      ga: cookieValue('_ga', 200),
      clarity: cookieValue('_clck', 200),
      yandex: snapshot.yandex_client_id || cookieValue('_ym_uid', 200)
    });
  }

  function currentCampaign() {
    var params = new URLSearchParams(window.location.search);
    var utm = compact({
      source: parameter(params, ['utm_source']),
      medium: parameter(params, ['utm_medium']),
      campaign: parameter(params, ['utm_campaign']),
      id: parameter(params, ['utm_id']),
      content: parameter(params, ['utm_content']),
      term: parameter(params, ['utm_term'])
    });
    var meta = compact({
      adset_id: parameter(params, ['meta_adset_id']),
      ad_id: parameter(params, ['meta_ad_id']),
      placement: parameter(params, ['meta_placement']),
      fbclid: parameter(params, ['fbclid'])
    });
    var google = compact({
      gclid: googleClickId(params),
      gbraid: parameter(params, ['gbraid']),
      wbraid: parameter(params, ['wbraid']),
      srsltid: parameter(params, ['srsltid']),
      campaign: parameter(params, ['campaign', 'campaignid']),
      adgroup: parameter(params, ['adgroup', 'adgroupid']),
      creative: parameter(params, ['creative']),
      keyword: parameter(params, ['keyword']),
      network: parameter(params, ['network']),
      device: parameter(params, ['device'])
    });
    var clicks = {};
    Object.keys(CLICK_ID_VENDORS).forEach(function (name) {
      var value = parameter(params, [name]);
      if (value) clicks[name] = value;
    });
    if (google.srsltid && !utm.source) {
      utm = compact({
        source: 'google',
        medium: utm.medium || 'organic',
        campaign: utm.campaign,
        id: utm.id,
        content: utm.content,
        term: utm.term
      });
    }
    return { utm: utm, meta: meta, google: google, clicks: clicks };
  }

  function hasKeys(value) {
    return value && Object.keys(value).length > 0;
  }

  function referrerHost(referrer) {
    if (!referrer) return '';
    try {
      return safeValue(new URL(referrer).hostname.replace(/^www\./, ''), 80);
    } catch (error) {
      return '';
    }
  }

  function isOwnHost(host) {
    if (!host) return false;
    var normalized = host.replace(/^www\./, '').toLowerCase();
    var current = referrerHost(window.location.origin);
    if (normalized === current) return true;
    for (var i = 0; i < STORE_HOSTS.length; i += 1) {
      var storeHost = STORE_HOSTS[i];
      if (normalized === storeHost || normalized.slice(-(storeHost.length + 1)) === '.' + storeHost) return true;
    }
    return false;
  }

  function aiSource(host) {
    return AI_REFERRERS[host] || '';
  }

  function paidVendor(campaign) {
    if (!campaign) return null;
    if (campaign.google && (campaign.google.gclid || campaign.google.gbraid || campaign.google.wbraid)) {
      return { source: 'google', medium: 'cpc' };
    }
    if (campaign.meta && campaign.meta.fbclid) return { source: 'meta', medium: 'paid_social' };
    var clicks = campaign.clicks || {};
    var names = Object.keys(CLICK_ID_VENDORS);
    for (var i = 0; i < names.length; i += 1) {
      if (clicks[names[i]]) return CLICK_ID_VENDORS[names[i]];
    }
    return null;
  }

  function knownClickId(value) {
    if (!value) return false;
    var touches = [snapshot.last_non_direct_touch, snapshot.first_touch].concat(snapshot.visits || []);
    for (var i = 0; i < touches.length; i += 1) {
      var google = touches[i] && touches[i].google;
      if (google && google.gclid === value) return true;
    }
    return false;
  }

  function googleClickId(params) {
    var fromUrl = parameter(params, ['gclid']);
    if (fromUrl) return fromUrl;
    return '';
  }

  function isSearchHost(host) {
    if (!host) return false;
    return /(^|\.)google\./.test(host) ||
      /(^|\.)bing\./.test(host) ||
      /(^|\.)yandex\./.test(host) ||
      /(^|\.)yahoo\./.test(host) ||
      host === 'duckduckgo.com' ||
      host === 'baidu.com' ||
      host === 'ecosia.org';
  }

  function hasPaidGoogle(google) {
    if (!google) return false;
    return !!(google.gclid || google.gbraid || google.wbraid || google.campaign || google.adgroup || google.creative || google.keyword || google.network || google.device);
  }

  function classification(campaign, referrer) {
    var host = referrerHost(referrer);
    var utm = campaign.utm || {};
    var paid = paidVendor(campaign);
    if (paid || hasPaidGoogle(campaign.google)) {
      return {
        channel: 'paid',
        source: utm.source || (paid && paid.source) || 'paid',
        medium: utm.medium || (paid && paid.medium) || 'paid'
      };
    }
    var explicitMedium = utm.medium ? String(utm.medium).toLowerCase() : '';
    if (explicitMedium === 'organic' || explicitMedium === 'seo') {
      return { channel: 'organic', source: utm.source || 'organic', medium: 'organic' };
    }
    if (hasKeys(utm)) return { channel: 'paid', source: utm.source || 'paid', medium: utm.medium || 'paid' };
    if (campaign.google && campaign.google.srsltid) return { channel: 'organic', source: 'google', medium: 'organic' };
    if (isOwnHost(host)) return { channel: 'direct', source: 'direct', medium: 'direct' };
    if (isSearchHost(host)) return { channel: 'organic', source: host.split('.')[0], medium: 'organic' };
    var ai = aiSource(host);
    if (ai) return { channel: 'ai_referral', source: ai, medium: 'referral' };
    if (host) return { channel: 'referral', source: host, medium: 'referral' };
    return { channel: 'direct', source: 'direct', medium: 'direct' };
  }

  function channelOf(campaign, referrer) {
    return classification(campaign, referrer).channel;
  }

  function isNonDirect(campaign) {
    var channel = channelOf(campaign, document.referrer);
    return channel !== 'direct';
  }

  function makeTouch(sessionId, campaign, time) {
    var referrer = document.referrer;
    var classified = classification(campaign, referrer);
    return {
      utm: campaign.utm,
      meta: campaign.meta,
      google: campaign.google,
      clicks: campaign.clicks,
      source: classified.source,
      medium: classified.medium,
      landing: safeLocation(window.location.href),
      referrer: safeLocation(referrer),
      rh: referrerHost(referrer),
      ch: classified.channel,
      time: time,
      session: sessionId
    };
  }

  function shopifyVisitorId() {
    return cookieValue('_shopify_y', 200);
  }

  function shopifySessionId() {
    return cookieValue('_shopify_s', 200);
  }

  function getSession() {
    var shopifySession = shopifySessionId();
    if (!shopifySession) return { id: '', isNew: false };
    var previous = snapshot.last_visit && snapshot.last_visit.session;
    return { id: shopifySession, isNew: previous !== shopifySession };
  }

  function waitForShopifyThenCapture() {
    if (shopifyRetry >= 50) {
      capture(true);
      return;
    }
    shopifyRetry += 1;
    window.setTimeout(function () {
      if (shopifyVisitorId()) {
        shopifyRetry = 0;
        capture(false);
        return;
      }
      waitForShopifyThenCapture();
    }, 100);
  }

  function touchSignature(touch) {
    if (!touch) return '';
    var utm = touch.utm || {};
    var meta = touch.meta || {};
    var google = touch.google || {};
    return [
      touch.ch || '',
      utm.source || '',
      utm.medium || '',
      utm.campaign || '',
      google.gclid || '',
      JSON.stringify(touch.clicks || {}),
      google.srsltid || '',
      meta.fbclid || '',
      touch.landing || ''
    ].join('|');
  }

  function visitClickId(touch) {
    if (!touch) return '';
    var google = touch.google || {};
    return google.gclid || google.gbraid || google.wbraid || (touch.meta && touch.meta.fbclid) || JSON.stringify(touch.clicks || {});
  }

  function isInternalPaidRepeat(touch, previous) {
    if (!touch || !previous || touch.ch !== 'paid' || previous.ch !== 'paid') return false;
    var clickId = visitClickId(touch);
    if (!clickId || clickId !== visitClickId(previous)) return false;
    if (previous.session && touch.session && previous.session !== touch.session) return false;
    return isOwnHost(touch.rh || referrerHost(touch.referrer));
  }

  function appendVisit(touch, now) {
    if (!touch) return;
    var visits = Array.isArray(snapshot.visits) ? snapshot.visits : [];
    var last = visits[visits.length - 1];
    var signature = touchSignature(touch);
    if (last && touchSignature(last) === signature && last.session === touch.session) return;
    if (touch.ch === 'direct' && last && last.session === touch.session) return;
    if (isInternalPaidRepeat(touch, last)) return;
    var entry = clone(touch);
    if (!entry) return;
    if (last && last.time) {
      entry.seconds_since_previous = Math.max(0, Math.floor((now - Date.parse(last.time)) / 1000));
    }
    visits.push(entry);
    snapshot.visits = visits.slice(-MAX_VISITS);
  }

  function countUniqueSessions(visits, firstTouch, lastVisit) {
    var sessions = {};
    (visits || []).forEach(function (visit) {
      if (visit && visit.session) sessions[visit.session] = 1;
    });
    if (firstTouch && firstTouch.session) sessions[firstTouch.session] = 1;
    if (lastVisit && lastVisit.session) sessions[lastVisit.session] = 1;
    return Object.keys(sessions).length;
  }

  function resolveTotalSessions(value) {
    var stored = Number(value && value.total_sessions);
    if (Number.isFinite(stored) && stored > 0) return stored;
    var counted = countUniqueSessions(value && value.visits, value && value.first_touch, value && value.last_visit);
    return counted > 0 ? counted : 0;
  }

  function touchCapturedAt(touch) {
    if (!touch || !touch.time) return '';
    var parsed = Date.parse(touch.time);
    return Number.isNaN(parsed) ? '' : touch.time;
  }

  function daysBetween(isoStart, isoEnd) {
    if (!isoStart || !isoEnd) return 0;
    var start = Date.parse(isoStart);
    var end = Date.parse(isoEnd);
    if (Number.isNaN(start) || Number.isNaN(end)) return 0;
    return Math.max(0, Math.floor((end - start) / 86400000));
  }

  function daysToConversion(firstTouch, lastTouch) {
    var firstAt = touchCapturedAt(firstTouch);
    var lastAt = touchCapturedAt(lastTouch) || new Date().toISOString();
    if (!firstAt) return 0;
    return daysBetween(firstAt, lastAt);
  }

  function journeySummary(value) {
    if (!value) return null;
    var firstAt = touchCapturedAt(value.first_touch);
    var lastAt = touchCapturedAt(value.last_visit || value.last_non_direct_touch);
    return compact({
      total_sessions: resolveTotalSessions(value),
      days_to_conversion: daysToConversion(value.first_touch, value.last_visit || value.last_non_direct_touch),
      first_visit_at: firstAt,
      last_visit_at: lastAt
    });
  }

  function capture(forceWithoutShopify) {
    if (!state.analyticsAllowed && !state.marketingAllowed) return;
    var shopifyId = shopifyVisitorId();
    if (!shopifyId && !forceWithoutShopify) {
      waitForShopifyThenCapture();
      return;
    }
    snapshot = readStored();
    var now = Date.now();
    var time = new Date(now).toISOString();
    var session = getSession();
    var campaign = state.marketingAllowed ? currentCampaign() : { utm: {}, meta: {}, google: {} };
    var touch = makeTouch(session.id, campaign, time);

    if (shopifyId) snapshot.visitor_id = shopifyId;
    if (state.marketingAllowed && !snapshot.first_touch) snapshot.first_touch = touch;
    if (state.marketingAllowed && isNonDirect(campaign)) snapshot.last_non_direct_touch = touch;
    if (state.marketingAllowed) appendVisit(touch, now);
    snapshot.last_visit = touch;
    if (session.isNew || !snapshot.total_sessions) {
      snapshot.total_sessions = resolveTotalSessions(snapshot);
    }

    if (!hasStoredMarks()) return;

    persist();
    requestYandexClientId();
    identifyClarity();
  }

  function scheduleLateCapture() {
    if (lateCaptureScheduled) return;
    lateCaptureScheduled = true;
    window.setTimeout(function () {
      if (!state.analyticsAllowed && !state.marketingAllowed) return;
      capture();
    }, LATE_CAPTURE_MS);
  }

  function normalizeRegion(value) {
    return safeValue(typeof value === 'string' ? value : '', 8).toUpperCase();
  }

  function customerPrivacy() {
    return window.Shopify && window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy : null;
  }

  function allowed(api, method) {
    try {
      return typeof api[method] === 'function' && api[method]() === true;
    } catch (error) {
      return false;
    }
  }

  function currentConsent(api) {
    try {
      if (typeof api.currentVisitorConsent !== 'function') return {};
      return api.currentVisitorConsent() || {};
    } catch (error) {
      return {};
    }
  }

  function evaluateConsent() {
    var api = customerPrivacy();
    var market = normalizeRegion(window.theme && window.theme.shopifyCountry);
    var region = '';

    if (api && typeof api.getRegion === 'function') {
      try {
        region = normalizeRegion(api.getRegion());
      } catch (error) {
        region = '';
      }
    }

    var strict = !!STRICT_COUNTRIES[market];
    var consent = api ? currentConsent(api) : {};
    var analyticsAllowed = true;
    var marketingAllowed = true;

    if (strict) {
      if (!api) {
        analyticsAllowed = false;
        marketingAllowed = false;
      } else {
        analyticsAllowed = allowed(api, 'analyticsProcessingAllowed');
        marketingAllowed = allowed(api, 'marketingAllowed');
      }
    } else {
      if (consent.analytics === 'no') analyticsAllowed = false;
      if (consent.marketing === 'no') marketingAllowed = false;
    }

    state.policy = strict ? 'strict' : 'non_strict';
    state.region = region || market;
    state.analyticsAllowed = analyticsAllowed;
    state.marketingAllowed = marketingAllowed;
    state.initialized = !!api || !strict;

    if (analyticsAllowed || marketingAllowed) {
      capture();
      scheduleLateCapture();
    } else if (strict || (consent.analytics === 'no' && consent.marketing === 'no')) {
      clearStored();
    }

    publishReady();
  }

  function publicSnapshot() {
    if (!state.analyticsAllowed && !state.marketingAllowed) return null;
    var value = clone(snapshot);
    if (!value) return null;
    delete value.expires_at;
    if (!state.marketingAllowed) {
      value.first_touch = null;
      value.last_non_direct_touch = null;
      value.visits = [];
    }
    if (!state.analyticsAllowed) {
      value.visitor_id = '';
      value.yandex_client_id = '';
    }
    value.journey = journeySummary(value);
    return value;
  }

  function encodeTouch(touch) {
    if (!touch) return '';
    try {
      var packed = packMarks(touch);
      var raw = JSON.stringify(packed);
      return raw.length > 2500 ? '' : raw;
    } catch (error) {
      return '';
    }
  }

  function cartPayload() {
    var value = publicSnapshot();
    var attributes = {};
    attributes[CART_FIRST] = '';
    attributes[CART_LAST] = '';
    attributes[CART_META] = '';
    if (value) {
      var live = livePixelIds();
      var summary = value.journey || journeySummary(value);
      attributes[CART_FIRST] = encodeTouch(value.first_touch);
      attributes[CART_LAST] = encodeTouch(value.last_non_direct_touch);
      try {
        attributes[CART_META] = JSON.stringify(compact({
          visitor_id: value.visitor_id,
          session: live.shopify_s,
          first_session_id: value.first_touch && value.first_touch.session ? value.first_touch.session : '',
          last_session_id: value.last_visit && value.last_visit.session ? value.last_visit.session : live.shopify_s,
          total_sessions: summary && summary.total_sessions,
          days_to_conversion: summary && summary.days_to_conversion,
          first_visit_at: summary && summary.first_visit_at,
          last_visit_at: summary && summary.last_visit_at,
          policy: state.policy,
          visits: (value.visits || []).map(packMarks).slice(-5),
          fbp: live.fbp,
          fbc: live.fbc,
          gcl_aw: live.gcl_aw,
          gcl_au: live.gcl_au,
          ga: live.ga,
          clarity: live.clarity,
          yandex: live.yandex
        }));
      } catch (error) {
        attributes[CART_META] = '';
      }
    }
    if (!attributes[CART_FIRST] && !attributes[CART_LAST] && !attributes[CART_META] && !lastSyncKey) {
      return null;
    }
    return { attributes: attributes };
  }

  function cartUpdateUrl() {
    var route = window.Theme && window.Theme.routes && window.Theme.routes.cart_update_url;
    var url = route || '/cart/update.js';
    return url.indexOf('.js') === -1 ? url + '.js' : url;
  }

  function queueCartSync() {
    if (syncPromise) return syncPromise;
    syncPromise = syncToCart().finally(function () {
      syncPromise = null;
    });
    return syncPromise;
  }

  function syncToCart() {
    var payload = cartPayload();
    if (!payload) return Promise.resolve(false);
    var key = JSON.stringify(payload.attributes);
    if (key === lastSyncKey) return Promise.resolve(true);

    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = window.setTimeout(function () {
      if (controller) controller.abort();
    }, SYNC_TIMEOUT);

    return fetch(cartUpdateUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload),
      signal: controller ? controller.signal : undefined
    }).then(function (response) {
      if (!response.ok) return false;
      lastSyncKey = key;
      return true;
    }).catch(function () {
      return false;
    }).finally(function () {
      window.clearTimeout(timer);
    });
  }

  function publishReady() {
    readySequence += 1;
    window.dataLayer = window.dataLayer || [];
    var payload = {
      event: 'visit_context_ready',
      visit_policy: state.policy,
      visit_region: state.region || 'unknown',
      analytics_allowed: state.analyticsAllowed,
      marketing_allowed: state.marketingAllowed,
      visit_sequence: readySequence
    };
    var value = publicSnapshot();
    if (value) payload.visit_context = value;
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent('theme:visit-context', {
      detail: {
        policy: state.policy,
        region: state.region,
        analyticsAllowed: state.analyticsAllowed,
        marketingAllowed: state.marketingAllowed
      }
    }));
  }

  function requestYandexClientId() {
    if (!state.analyticsAllowed || typeof window.ym !== 'function') return;
    try {
      window.ym(104111919, 'getClientID', function (clientId) {
        if (!state.analyticsAllowed) return;
        var safeId = safeValue(String(clientId || ''), 100);
        if (!safeId || safeId === snapshot.yandex_client_id) return;
        snapshot.yandex_client_id = safeId;
        persist();
        publishReady();
      });
    } catch (error) {
      return;
    }
  }

  function identifyClarity() {
    if (!state.analyticsAllowed || typeof window.clarity !== 'function') return;
    var visitorId = snapshot.visitor_id;
    var sessionId = snapshot.last_visit && snapshot.last_visit.session;
    if (!visitorId || !sessionId) return;
    var identity = visitorId + ':' + sessionId;
    if (identity === clarityIdentity) return;
    clarityIdentity = identity;
    try {
      window.clarity('identify', visitorId, sessionId, safeValue(window.location.pathname, 200));
    } catch (error) {
      clarityIdentity = '';
    }
  }

  window.ThemeVisitContext = {
    getSnapshot: function () {
      return publicSnapshot();
    },
    isAnalyticsAllowed: function () {
      return state.analyticsAllowed;
    },
    isMarketingAllowed: function () {
      return state.marketingAllowed;
    },
    getPolicy: function () {
      return {
        mode: state.policy,
        region: state.region,
        initialized: state.initialized
      };
    },
    syncToCart: queueCartSync,
    refreshConsent: evaluateConsent,
    refreshYandexClientId: requestYandexClientId,
    refreshClarityIdentity: identifyClarity
  };

  document.addEventListener('submit', function (event) {
    var form = event.target;
    var submitter = event.submitter;
    if (!form || form.tagName !== 'FORM' || !submitter) return;
    if (submitter.name !== 'checkout' && submitter.id !== 'checkout') return;
    if (form.getAttribute('data-ctx-ready') === '1') {
      form.removeAttribute('data-ctx-ready');
      return;
    }
    event.preventDefault();
    queueCartSync().finally(function () {
      form.setAttribute('data-ctx-ready', '1');
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitter);
      } else {
        HTMLFormElement.prototype.submit.call(form);
      }
    });
  }, true);

  document.addEventListener('shopifyCustomerPrivacyApiLoaded', evaluateConsent);
  document.addEventListener('visitorConsentCollected', evaluateConsent);
  evaluateConsent();
})();
